import profilePic from '../../assets/profilePic.png';

interface TestimonialsDataType {
	profilePic: string;
	name: string;
	industry: string;
	comment: string;
	id: number;
}

export const testimonialsData: TestimonialsDataType[] = [
	{
		id: 1,
		profilePic: profilePic,
		name: 'Muradyan Gagik',
		industry: 'IT',
		comment:
			'Partnering with ITG is valuable for us. With the technical and operational support provided by ITG, we access to the large variety of SWIFT services and payment options including global and cross-border payments. What is more, in the frames of the partnership with ITG, we get control over the SWIFT environment and keep our infrastructure up-to-date. ITG team is knowledgeable. They quickly understand our issues and find solutions that meet all the items on our list of functional and technical requirements.'
	},
	{
		id: 2,
		profilePic: profilePic,
		name: 'Alanakyan Andranik',
		industry: 'IT',
		comment:
			'We started working with ITG a few years ago and thanks to the best assistance and technical support from ITG experts we have gained a considerable experience in executing in-coming and out-going international financial transactions within SWIFT system. ITG provides solutions and services that answer our needs and allow operating smoothly in SWIFT platform while enabling to comply with the latest international regulations. It is a real pleasure to work with ITG team.'
	},
	{
		id: 3,
		profilePic: profilePic,
		name: 'Voskanov Tigran',
		industry: 'IT',
		comment:
			'We chose ITG as it is a great partner offering all the SWIFT solutions we were looking for. Outsourcing of complete financial messaging services for SWIFT to ITG Service Bureau gives us a great opportunity to establish modular solutions that could always adapt to new business models and changing requirements. Partnering with ITG, we are sure that will gain SWIFT connectivity and infrastructure in a reliable environment with full backup, upgrades and on-going support.'
	}
	// {
	// 	id: 4,
	// 	profilePic: profilePic,
	// 	name: 'Alanakyan Andranik',
	// 	industry: 'IT',
	// 	comment:
	// 		'We started working with ITG a few years ago and thanks to the best assistance and technical support from ITG experts we have gained a considerable experience in executing in-coming and out-going international financial transactions within SWIFT system. ITG provides solutions and services that answer our needs and allow operating smoothly in SWIFT platform while enabling to comply with the latest international regulations. It is a real pleasure to work with ITG team.'
	// }
];

export type FAQ = {
	question: string;
	answer: string;
	hasLink?: boolean;
};

export const faqData: FAQ[] = [
	{
		question: 'Why Do Banks and Financial Institutions Prefer to Outsource Their Swift Connection?',
		answer: `Outsourcing SWIFT connectivity and infrastructure has become increasingly popular in recent years as a way of reducing maintenance and system support costs and improving level of performance in the SWIFT environment. SWIFT Service Bureau provides the ability to focus on core business competencies. By outsourcing to SWIFT Service Bureau, banks and financial institutions can be confident that will get fast and secure access to the full suite of SWIFT services, as well as will have the opportunity to reduce operational costs and risks.`
	},
	{
		question: 'Are You Swift-certified?',
		answer: `Yes, we are certified by SWIFT. Today ITG is the only fully accredited partner of SWIFT in Armenia that provides banks and financial institutions with access to the complete range of SWIFT services. Using the status of the SWIFT Service Bureau, our company delivers the opportunity to communicate with more than 11 thousand banks and other financial institutions in more than 200 countries and territories and send/receive information about financial transactions in a secure, standardized and reliable environment.`,
		hasLink: true
	},
	{
		question: 'How Reliable is Your Service Bureau?',
		answer: `Our service bureau is designed with reliability and security in mind, ensuring seamless operations.`
	},
	{
		question: 'What Key Benefits Does Your Service Bureau Offer?',
		answer: `We provide reduced operational costs, streamlined connectivity, and 24/7 support.`
	},
	{
		question: 'How Can We Control and Monitor Our Company’s Swift Environment?',
		answer: `Our platform offers intuitive dashboards and monitoring tools to ensure compliance and transparency.`
	}
];
